import React, { useCallback } from 'react';

import { Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { commonCloseError } from '@/store/common/actions';
import { ErrorState } from '@/store/common/selector';

import { CloseOrangeIcon } from '@/assets';
import { Dialog } from './Dialog';
import { Trans, useTranslation } from 'react-i18next';
import { ErrorCodeLogin } from '@/constants';
import { Link } from 'react-router-dom';

export const DialogError = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const error = useSelector(ErrorState);

  const email = localStorage.getItem('email');

  const handleCloseError = () => {
    dispatch(commonCloseError());
    if (!error.action) return;
    if (error.action) {
      dispatch({ type: error.action });
    }
  };

  const renderTitle = useCallback(() => {
    if (error.errorCode === ErrorCodeLogin.NO_COMMISSION_RATE) {
      return t('No commission rate');
    }
    if (error.errorCode === ErrorCodeLogin.USER_DISABLE) {
      return t('Inactive account');
    }

    if (error.errorCode === ErrorCodeLogin.USER_LOCKED) {
      return t('Maximum login attempts');
    }

    if (error.errorCode === ErrorCodeLogin.USER_DELETED) {
      return t('Account not available');
    }
    return error.message;
  }, [error.errorCode, error.message, t]);

  const renderDescription = useCallback(() => {
    if (error.errorCode === ErrorCodeLogin.NO_COMMISSION_RATE) {
      return t('Before referring users, please get in touch with the CEO to discuss adding your commission rate.');
    }
    if (error.errorCode === ErrorCodeLogin.USER_DISABLE) {
      return t('Your account has been disabled, please contact your manager to reactivate your account');
    }
    if (error.errorCode === ErrorCodeLogin.USER_LOCKED) {
      return (
        <Trans
          i18nKey="auth.limit_login_des"
          values={{ title: 'Kakao' }}
          components={{ anchor: <a href={'https://open.kakao.com/o/sOU7L79b'} target="_blank" /> }}
        />
      );
    }
    if (error.errorCode === ErrorCodeLogin.USER_DELETED) {
      return t('Your account has been deleted. Please contact the CEO for more details.');
    }
    return '';
  }, [error.errorCode, t]);

  return (
    <Dialog
      isOpen={error.open}
      handleClose={() => handleCloseError()}
      className="titan-modal"
      wrapClassName="dialog-error"
    >
      <>
        <div className="titan-modal__content center">
          <div className="box-icon">
            <CloseOrangeIcon />
          </div>
          <div className="title ">{renderTitle()}</div>
          <div className="description ">{renderDescription()}</div>
        </div>
        <div className="titan-modal__footer">
          <div className="actions center">
            <Button type="primary" size="large" className="btn-orange" onClick={() => handleCloseError()}>
              Got It
            </Button>
          </div>
        </div>
      </>
    </Dialog>
  );
};
export default DialogError;
